import { useMutation } from "react-query";
import { saveAppointments } from "../v1/services";
import { useContext } from "react";

import usePopup from "../../../hooks/usePopup";
import { initialBooking } from "../v1/types";
import { PatientBookingContext } from "./context/PatientBookingProvider";
const useBookingSave = (callOnSuccess?:()=>void | undefined) => {
  const { setOpen, setRefetch, setTimeSlot } = useContext(
    PatientBookingContext
  );
  const { showSnackbar } = usePopup();
  return useMutation(saveAppointments, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setOpen(false);
        setRefetch(true);
        setTimeSlot(initialBooking.timeSlot);
        showSnackbar({
          message: result.responseMessage,
          variant: "success",
          open: true,
          duration: 2000,
        });
        if(callOnSuccess){
          callOnSuccess()
        }
      } else {
        showSnackbar({
          message: result.responseMessage,
          variant: "warning",
          open: true,
          duration: 2000,
        });
      }
    },
    onError: (error: any) => {
      showSnackbar({
        message:
          error?.response?.data?.responseMessage || "Something went wrong !",
        variant: "warning",
        open: true,
        duration: 2000,
      });
    },
  });
};

export default useBookingSave;


